"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AptosStandardProvider = void 0;
const protocol_1 = require("../../../protocol");
const utils_1 = require("../../../utils");
const misc_1 = require("./misc");
class AptosStandardProvider {
    constructor(wallet) {
        this.wallet = wallet;
        this.mainNetWorkInfo = {
            chainId: "1",
            name: misc_1.AptosNetwork.MAINNET
        };
    }
    getVersion() {
        return this.wallet.version;
    }
    supportChains(chains) {
        if (chains.length === 1 && chains[0] === protocol_1.APTOS_CHAINS.MAINNET) {
            return true;
        }
        return false;
    }
    send(request) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e;
            try {
                try {
                    (0, utils_1.logDebug)("AptosStandardProvider send request:", JSON.stringify(request));
                }
                catch (error) {
                }
                yield this.confirmNetwrok(request.chainId);
                const method = request.method;
                let result;
                if (request.injectParams && this.wallet) {
                    let originalParams = request.injectParams;
                    switch (method) {
                        case "aptos_signTransaction":
                            let injectSignResult;
                            if (this.wallet.features['aptos:signTransaction']) {
                                if ("rawTransaction" in originalParams) {
                                    const response = yield this.wallet.features['aptos:signTransaction'].signTransaction(originalParams);
                                    injectSignResult = (0, misc_1.getArgs)(response);
                                }
                                else if (this.wallet.features['aptos:signTransaction'].version === "1.1") {
                                    const originalParams1 = originalParams;
                                    const signTransactionV1_1StandardInput = {
                                        payload: originalParams1.data,
                                        expirationTimestamp: (_a = originalParams1.options) === null || _a === void 0 ? void 0 : _a.expirationTimestamp,
                                        expirationSecondsFromNow: (_b = originalParams1.options) === null || _b === void 0 ? void 0 : _b.expirationSecondsFromNow,
                                        gasUnitPrice: (_c = originalParams1 === null || originalParams1 === void 0 ? void 0 : originalParams1.options) === null || _c === void 0 ? void 0 : _c.gasUnitPrice,
                                        maxGasAmount: (_d = originalParams1 === null || originalParams1 === void 0 ? void 0 : originalParams1.options) === null || _d === void 0 ? void 0 : _d.maxGasAmount,
                                        sequenceNumber: (_e = originalParams1 === null || originalParams1 === void 0 ? void 0 : originalParams1.options) === null || _e === void 0 ? void 0 : _e.accountSequenceNumber,
                                        sender: originalParams1.sender,
                                    };
                                    const response = yield this.wallet.features['aptos:signTransaction'].signTransaction(signTransactionV1_1StandardInput);
                                    injectSignResult = (0, misc_1.getArgs)(result);
                                }
                                else {
                                    throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.METHOD_NOT_SUPPORTED);
                                }
                            }
                            else {
                                throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.METHOD_NOT_SUPPORTED);
                            }
                            result = {
                                method: "aptos_signTransaction",
                                injectResult: injectSignResult
                            };
                            break;
                        case "aptos_signMessage":
                            let signMessageResult;
                            if (this.wallet.features['aptos:signMessage']) {
                                let result = yield this.wallet.features['aptos:signMessage'].signMessage(originalParams);
                                signMessageResult = (0, misc_1.getArgs)(result);
                            }
                            else {
                                throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.METHOD_NOT_SUPPORTED);
                            }
                            result = {
                                method: "aptos_signMessage",
                                injectResult: signMessageResult
                            };
                            break;
                        case "aptos_signAndSubmitTransaction":
                            let transactionResult;
                            if (this.wallet.features['aptos:signAndSubmitTransaction']) {
                                if (this.wallet.features['aptos:signAndSubmitTransaction'].version == '1.0.0') {
                                    if ('standardV1Transaction' in originalParams) {
                                        let result = yield this.wallet.features['aptos:signAndSubmitTransaction'].signAndSubmitTransaction(originalParams.standardV1Transaction);
                                        transactionResult = (0, misc_1.getArgs)(result);
                                    }
                                }
                                else if (this.wallet.features['aptos:signAndSubmitTransaction'].version == '1.1.0') {
                                    if ('standardV11Transaction' in originalParams) {
                                        let params = request.params;
                                        let result = yield this.wallet.features['aptos:signAndSubmitTransaction'].signAndSubmitTransaction(originalParams.standardV11Transaction);
                                        transactionResult = (0, misc_1.getArgs)(result);
                                    }
                                }
                                else {
                                    throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.METHOD_NOT_SUPPORTED);
                                }
                            }
                            else {
                                throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.METHOD_NOT_SUPPORTED);
                            }
                            result = {
                                method: "aptos_signAndSubmitTransaction",
                                result: transactionResult.hash.toString()
                            };
                            break;
                    }
                }
                return result;
            }
            catch (e) {
                (0, utils_1.logDebug)("aptosProvider send error:", e);
                throw e;
            }
        });
    }
    removeListener() {
        this.previousAccountChangedListener = undefined;
    }
    addAccountChangedListener(accountChangedListener) {
        this.accountChangedListener = accountChangedListener;
        // if (this.wallet.features['aptos:onNetworkChange']) {
        //     (this.wallet.features['aptos:onNetworkChange'] as any).onNetworkChange((networkInfo:any)=>{
        //
        //     })
        // }
    }
    setAccountChangedListener() {
        if (this.previousAccountChangedListener == this.accountChangedListener) {
            return;
        }
        if (this.wallet.features['aptos:onAccountChange'] && this.accountChangedListener) {
            try {
                this.wallet.features['aptos:onAccountChange'].onAccountChange((accountInfo) => {
                    var _a, _b, _c, _d;
                    try {
                        let address = (_b = (_a = (0, misc_1.getArgs)(accountInfo)) === null || _a === void 0 ? void 0 : _a.address) === null || _b === void 0 ? void 0 : _b.toString();
                        if (this.address != address) {
                            this.accountChangedListener((_d = (_c = (0, misc_1.getArgs)(accountInfo)) === null || _c === void 0 ? void 0 : _c.address) === null || _d === void 0 ? void 0 : _d.toString());
                            this.address = address;
                        }
                    }
                    catch (e) {
                        if (this.address) {
                            this.accountChangedListener(undefined);
                            this.address = undefined;
                        }
                    }
                });
                this.previousAccountChangedListener = this.accountChangedListener;
            }
            catch (err) {
                (0, utils_1.logDebug)(`aptosStandardProvider addAccountChangedListener: error ${err.toString()}`);
            }
        }
    }
    connect() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.wallet.features["aptos:connect"].connect();
        });
    }
    getAccount() {
        return __awaiter(this, void 0, void 0, function* () {
            let account = (0, misc_1.getArgs)(yield this.connect());
            let address = account.address;
            if (typeof address === 'object' && address.toString) {
                address = address.toString();
            }
            if (address instanceof Uint8Array) {
                address = this.normalizeUint8Array(address);
                address = btoa(String.fromCharCode(...address));
            }
            let publicKey = account.publicKey.toString();
            if (this.address !== address) {
                this.setAccountChangedListener();
                this.address = address;
            }
            let extra = {};
            extra[protocol_1.APTOS_CHAINS.MAINNET] = { publicKey: publicKey };
            return {
                namespace: protocol_1.NameSpaceKeyAptos,
                addresses: [`${protocol_1.APTOS_CHAINS.MAINNET}:${address}`],
                methods: [],
                extra: extra
            };
        });
    }
    normalizeUint8Array(data) {
        if (data.length === 33 && data[0] === 0) {
            return data.slice(1);
        }
        return data;
    }
    disconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.wallet.features['aptos:disconnect']) {
                return this.wallet.features["aptos:disconnect"].disconnect();
            }
        });
    }
    confirmNetwrok(chainid) {
        return __awaiter(this, void 0, void 0, function* () {
            if (chainid !== utils_1.chainName2IdMap.get(protocol_1.APTOS_CHAINS.MAINNET)) {
                throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.CHAIN_NOT_SUPPORTED);
            }
            if (this.wallet.features['aptos:network']) {
                let walletNetwork = yield this.wallet.features['aptos:network'].network();
                if (walletNetwork.chainId == 1 && walletNetwork.name.toLowerCase() == misc_1.AptosNetwork.MAINNET) {
                    return Promise.resolve();
                }
                yield this.changeMainNetwork();
            }
            else {
                throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.METHOD_NOT_SUPPORTED);
            }
        });
    }
    changeMainNetwork() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.wallet.features['aptos:changeNetwork']) {
                let result = yield (this.wallet.features['aptos:changeNetwork'].changeNetwork(this.mainNetWorkInfo));
                let changeNetworkResult = (0, misc_1.getArgs)(result);
                if (changeNetworkResult.success) {
                    return Promise.resolve();
                }
            }
            else {
                throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.METHOD_NOT_SUPPORTED);
            }
        });
    }
}
exports.AptosStandardProvider = AptosStandardProvider;
